<!--  -->
<template>
    <div class=''>


        <el-row type="flex" class="row-bg">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>招聘信息</span>
                        <el-button style="float: right; padding: 3px 0" type="text"
                            @click="editRecruitContentDialogVisible = true;oR = r;">
                            编辑</el-button>
                    </div>

                    <div class='content'>
                        <div class="recruit-info" v-html="r">

                        </div>
                        <div class="Item-add">
                            <a @click="editRecruitDialogVisible = true">- 发布招聘信息 -</a>
                        </div>
                        <el-table :data="rs" style="width: 100%; padding:  0 15px">
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <div v-html="props.row.content"></div>
                                </template>
                            </el-table-column>
                            <el-table-column label="职位" prop="recruitName" align="center">
                            </el-table-column>
                            <el-table-column label="部门" prop="recruitDepartment" align="center">
                            </el-table-column>
                            <el-table-column label="人数" width="50" prop="count" align="center">
                            </el-table-column>
                            <el-table-column label="工作地点" prop="wordAddress" align="center">
                            </el-table-column>
                            <!-- <el-table-column label="e-mail" prop="workingPlace" align="center">
                            </el-table-column> -->
                            <el-table-column label="状态" width="60" prop="isClose" align="center">
                            </el-table-column>
                            <el-table-column label="发布时间" prop="updateTime" align="center">
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" align="center" width="150">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="editRow(scope.row)" type="text" size="small">
                                        编辑
                                    </el-button>
                                    <el-button @click.native.prevent="closeRow(scope.row)" type="text" size="small">
                                        {{scope.row.isClose?'开启':'关闭'}}
                                    </el-button>
                                    <el-button @click.native.prevent="deleteRow(scope.row)" type="text" size="small">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>



                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-dialog title="编辑招聘提示" :visible.sync="editRecruitContentDialogVisible" width="1070px">
            <editor :api-key="editorConf.kkey" :init="editorConf" v-model="oR"></editor>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editRecruitContentDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploadHtmlContent">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="发布招聘信息" :visible.sync="editRecruitDialogVisible" width="1070px">

            <el-row :gutter="20" style="align-items: center; line-height: 40px;margin-bottom: 20px;">
                <el-col :span="2" style="text-align: right;">
                    职位
                </el-col>
                <el-col :span="5">
                    <el-input placeholder="请输入内容" clearable v-model="editR.recruitName">
                    </el-input>
                </el-col>
                <el-col :span="2" style="text-align: right;">
                    部门
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="请输入内容" clearable v-model="editR.recruitDepartment">
                    </el-input>
                </el-col>

                <el-col :span="2" style="text-align: right;">
                    人数
                </el-col>
                <el-col :span="3">
                    <el-input placeholder="请输入内容" clearable v-model="editR.count">
                    </el-input>
                </el-col>
                <el-col :span="2" style="text-align: right;">
                    工作地点
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="请输入内容" clearable v-model="editR.wordAddress">
                    </el-input>
                </el-col>
            </el-row>


            职位要求

            <editor :api-key="editorConf.kkey" :init="editorConf" v-model="editR.content"></editor>

            <span slot="footer" class="dialog-footer">
                <el-button @click="editRecruitDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editRecruit">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';

    var Editor = require("@tinymce/tinymce-vue").default;
    export default {
        //import引入的组件需要注入到对象中才能使用
        components: {
            editor: Editor // <- Important part
        },
        data() {
            //这里存放数据
            return {
                oR: "",
                r: "",
                editR: {},
                editRecruitContentDialogVisible: false,
                editRecruitDialogVisible: false,
                rs: [
                ]
            };
        },
        //监听属性 类似于data概念
        computed: {},
        //监控data中的数据变化
        watch: {},
        //方法集合
        methods: {
            uploadHtmlContent() {
                var that = this;
                this.$request.post({
                    url: "/api/admin/cover/recruit_t",
                    params: { html: that.oR },
                    callback: {
                        success: function (data) {
                            that.editRecruitContentDialogVisible = false;
                            that.r = data.data;
                        },
                        err: function (err) {
                            console.log(err);
                        }
                    }
                });
            },
            editRow(r) {
                this.editR = JSON.parse(JSON.stringify(r));
                this.editRecruitDialogVisible = true;
            },
            editRecruit() {
                var that = this;
                var url = "";
                if (that.editR.id > 0) {
                    url = "/api/admin/recruit/editRecruit";
                } else {
                    url = "/api/admin/recruit/addRecruit";
                }
                this.$request.post({
                    url: url,
                    params: that.editR,
                    callback: {
                        success: function (data) {
                            that.editRecruitDialogVisible = false
                            that.rs = data.data;
                        },
                        err: function (err) {
                            console.log(err);
                        }
                    }
                });
            },
            deleteRow(r) {

                var that = this;
                this.$alert("是否删除该职位", "提示", {
                    confirmButtonText: "确定",
                    callback: action => {
                        if (action == "confirm") {
                            var url = "/api/admin/recruit/delRecruit";
                            that.$request.post({
                                url: url,
                                params: { id: r.id },
                                callback: {
                                    success: function (data) {
                                        that.editRecruitDialogVisible = false
                                        that.rs = data.data;
                                    },
                                    err: function (err) {
                                        console.log(err);
                                    }
                                }
                            });
                        }
                    }
                });
            },
            closeRow(r) {
                var that = this;
                var url = "";
                if (r.isClose) {
                    url = "/api/admin/recruit/openRecruit";
                } else {
                    url = "/api/admin/recruit/closeRecruit";
                }
                this.$alert("是否" + (r.isClose ? "打开" : "关闭") + "该职位", "提示", {
                    confirmButtonText: "确定",
                    callback: action => {
                        if (action == "confirm") {

                            that.$request.post({
                                url: url,
                                params: { id: r.id },
                                callback: {
                                    success: function (data) {
                                        that.editRecruitDialogVisible = false
                                        that.rs = data.data;
                                    },
                                    err: function (err) {
                                        console.log(err);
                                    }
                                }
                            });
                        }
                    }
                });
            }
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {

        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {
            var that = this;
            this.$request.get({
                url: "/api/pageData/admin/recruit",
                callback: {
                    success: function (data) {
                        that.rs = data.data.rs;
                        that.r = data.data.r;
                    },
                    err: function (err) {
                        console.log(err);
                    }
                }
            });
        },
        beforeCreate() { }, //生命周期 - 创建之前
        beforeMount() { }, //生命周期 - 挂载之前
        beforeUpdate() { }, //生命周期 - 更新之前
        updated() { }, //生命周期 - 更新之后
        beforeDestroy() { }, //生命周期 - 销毁之前
        destroyed() { }, //生命周期 - 销毁完成
        activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style  scoped>
</style>